<template>

    <main class="middle" role="main">
        <div class="container">
            <div class="middle__wrapper">
                <h1 class="middle__header">Служба технической поддержки <span class="middle__header-marked">мобильных и веб-приложений</span></h1>
                <p class="middle__text">Какие задачи мы выполняем:</p>
                <ul class="middle__list">
                    <li class="middle__list-item">обеспечение бесперебойной работы приложений</li>
                    <li class="middle__list-item">доработка существующего и создание нового функционала</li>
                    <li class="middle__list-item">улучшение пользовательского опыта за счёт внесения изменений в интерфейс</li>
                    <li class="middle__list-item">устранение ошибок и выявление причин их возникновения</li>
                    <li class="middle__list-item">адаптация приложений под новые устройства и версии ОС</li>
                </ul>
                <div class="middle__disclamer">Нажимая кнопку «Написать сообщение», вы принимаете условия <a href="#" @click.prevent="showRules = true">Пользовательского соглашения</a></div>
                <a href="mailto:support.app@nami.ru" class="middle__btn">Написать сообщение</a>
            </div>
        </div>
    </main>

    <transition name="bounce">
        <Modal 
            v-if="showRules"
            size="lg"
            header="Пользовательское соглашение"
            @closeModal="showRules = false"
        >
            <template v-slot:body>

                <Rules />

            </template>
        </Modal>
    </transition>

</template>

<script>
import Modal from '@/components/Modal.vue'
import Rules from '@/components/Rules.vue'

export default {

    data() {

        return {

            showRules: false
        }
    },

    components: {

        Modal,
        Rules
    }
}
</script>

<style lang="scss">
@import '@/assets/styles/scss/components/middle';
</style>